import React from "react";
import styles from './PageSix.module.scss';
import BlockContainer from "./BlockContainer";
import { PAGE_6 } from "./assets";
import { goHome, dmmLogin } from "./Helper";
import { TwitterTimelineEmbed } from 'react-twitter-embed';
export default function PageSix() {
    const onClickDownload = () => {
        dmmLogin();
    }
    const onClickGoHome = () => {
        // goHome();
    }
    const btnClick = () => {
        dmmLogin();
    }
    return (
        <div className={styles["container"]}>
            <BlockContainer />
            <div className={styles["main-container"]}>
                <div className={styles["center-container"]}>
                    <img className={styles["twitter-bg"]} src={PAGE_6.Twitter_Pic.default} alt="" />
                    <TwitterTimelineEmbed
                        sourceType="profile"
                        screenName="twitter"
                        id="xxxx"
                        url="https://twitter.com/gyakuou_staff"
                        noBorders={true}
                        transparent={true}
                        options={{ height: 500, width: 820 }}
                    />
                </div>
                <div className={styles["buttons"]}>
                   {/*  <div>
                        <button className="fn-skip-detail" onClick={btnClick} type="button">
                            <img className={styles["dmm-login"]} src={PAGE_6.DOWNLOAD_BUTTON.default} alt="Download button"  />
                        </button>
                    </div> */}
                    <div>
                        <a href="https://games.dmm.com/detail/gyakuoudensetu/support/" target="_blank" rel="noreferrer">
                            <img src={PAGE_6.HOME_BUTTON.default} alt="Home button" />
                        </a>
                    </div>
                </div>

            </div>
        </div>
    )
}